import axios from 'axios';

import { AXIOS_DEFAULT_CONFIG, routes } from '../../constants';


export default async function byQrCode(qrCode) {
  const { data } = await axios.get(routes.ticketByQrCode, {
    ...AXIOS_DEFAULT_CONFIG,
    params: {
      qr_code: qrCode,
    },
  });

  return data;
}
